import { Scene } from 'scrollmagic'
import { BREAKPOINTS } from '/javascripts/constants/breakpoints'
import bus from '/javascripts/bus'
import UI from '/javascripts/utils/UI'
import scrollController from '/javascripts/utils/scrollController'

UI({
  component: '.js-stickySocialShare',
  sticky: '.js-stickySocialShare-sticky',
  layout: '.js-stickySocialShare-layout',
  toggle: '.js-stickySocialShare-toggle',
  socialButtons: '.js-stickySocialShare-socialButtons'
}, ({ component, sticky, layout, toggle, socialButtons }) => {
  const state = { scene: null }

  check()
  bus.on('windowResize', check)
  toggle.addEventListener('click', toggleSocialButtons)

  function check() {
    destroy()

    const shouldBeSticky = getSceneDuration() > 0
    if (window.matchMedia(`(min-width: ${BREAKPOINTS.LAPTOP}px)`).matches && shouldBeSticky) {
      create()
    }
  }

  function create() {
    state.scene = new Scene({
      triggerElement: component,
      triggerHook: getSceneTriggerHook(),
      duration: getSceneDuration()
    })
      .setPin(sticky, { pushFollowers: false })
      .addTo(scrollController)
  }

  function destroy() {
    state.scene && state.scene.destroy(true)
  }

  function getSceneDuration() {
    return component.clientHeight - layout.clientHeight
  }

  function getSceneTriggerHook() {
    return window.matchMedia(`(min-width: ${BREAKPOINTS.DESKTOP}px)`).matches
      ? 0
      : 120 / window.innerHeight
  }

  function toggleSocialButtons() {
    toggle.blur()
    socialButtons.classList.toggle('is-visible')
  }
})
